<template>
  <b-container class="blog-page-container">
    <b-row>
      <b-col>
        <div v-for="post in blogPosts" :key="post.id">
          <blog-post :postId="post.id"></blog-post>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import BlogPost from './components/BlogPost.vue';
import { mapGetters, mapActions } from 'vuex';
export default {
  components: {
    BlogPost
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters('blog', ['blogPosts'])
  },
  methods: {
    ...mapActions('blog', ['fetchBlogPosts'])
  },
  created() {
    if (this.blogPosts && this.blogPosts.length == 0) {
      this.fetchBlogPosts();
    }
  },
  mounted() {}
};
</script>

<style scoped>
.blog-page-container {
  padding-top: 3rem;
}
</style>
